import { VERTICALS } from '../data/verticals';
import VerticalPage from './VerticalPage';

const Coaching = () => <VerticalPage config={VERTICALS['coaching']} />;

export default Coaching;
